import React from "react";
import PropTypes from "prop-types";
import { Table } from "reactstrap";

export default function ReviewData(props) {
  const { name, email, title, type, sport, due, description } = props.request;

  return (
    <div>
      <p>Please review your request before submitting:</p>
      <Table>
        <tbody>
          <tr>
            <th scope="row">Name:</th>
            <td>{name.val}</td>
          </tr>
          <tr>
            <th scope="row">Email:</th>
            <td>{email.val}</td>
          </tr>
          <tr>
            <th scope="row">Title:</th>
            <td>{title.val}</td>
          </tr>
          <tr>
            <th scope="row">Type:</th>
            <td>{type.val}</td>
          </tr>
          <tr>
            <th scope="row">Sport:</th>
            <td>{sport.val}</td>
          </tr>
          <tr>
            <th scope="row">Due Date:</th>
            <td>{due.val.format("lll")}</td>
          </tr>
          <tr>
            <th scope="row">Description:</th>
            <td>{description.val}</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}

ReviewData.propTypes = {
  request: PropTypes.shape({
    name: PropTypes.shape({
      val: PropTypes.string.isRequired,
      isValid: PropTypes.bool
    }),
    email: PropTypes.shape({
      val: PropTypes.string.isRequired,
      isValid: PropTypes.bool
    }),
    title: PropTypes.shape({
      val: PropTypes.string.isRequired,
      isValid: PropTypes.bool
    }),
    type: PropTypes.shape({
      val: PropTypes.string.isRequired,
      isValid: PropTypes.bool
    }),
    due: PropTypes.shape({
      val: PropTypes.object.isRequired,
      isValid: PropTypes.bool
    }),
    description: PropTypes.shape({
      val: PropTypes.string.isRequired,
      isValid: PropTypes.bool
    })
  })
};

ReviewData.displayName = "ReviewData";



// WEBPACK FOOTER //
// ./src/Photo/ReviewData.js